import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from '../../api/client'

/** All communities (with my membership flag) — GET /communities. */
export function useCommunities() {
  return useQuery({ queryKey: ['communities'], queryFn: api.communities })
}

/** Join (POST) or leave (DELETE) a community, then refresh the list + detail. */
export function useToggleCommunity() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ id, joined }: { id: string; joined: boolean }): Promise<{ joined: boolean; members: number }> =>
      joined ? api.leaveCommunity(id) : api.joinCommunity(id),
    onSuccess: (_data, { id }) => {
      qc.invalidateQueries({ queryKey: ['communities'] })
      qc.invalidateQueries({ queryKey: ['community', id] })
    },
  })
}
